import { skipToken } from '@reduxjs/toolkit/query';
import { useGetRouteByIdQuery } from '../services/routes.service';

interface UseRouteDetailProps {
  routeId: string;
  skip?: boolean;
}

const useRouteDetail = ({ routeId, skip }: UseRouteDetailProps) => {
  const { data, isLoading, error } = useGetRouteByIdQuery(
    skip || !routeId
      ? skipToken
      : {
          routeId,
        },
    { refetchOnMountOrArgChange: true }
  );

  return {
    isLoading,
    error,
    routeDetail: data,
  };
};

export default useRouteDetail;

